import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputMultipleLines from '../../components/shared/inputs/InputMultipleLines';

const TypeFormat = ({ idpConfig, updateIdpConfigCallback, selectedFormat, setSelectedFormat }) => {
  const handleChange = (event) => {
    setSelectedFormat(event.target.value);
  };

  const handleUrlInputChange = (event) => {
    updateIdpConfigCallback({ metadataUrl: event.target.value });
  };

  const handleXmlInputChange = (event) => {
    updateIdpConfigCallback({ metadataXml: event.target.value });
  };

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectedFormat}
        onChange={handleChange}
      >
        <FormControlLabel value="URL" control={<Radio />} label="URL" />
        <FormControlLabel value="XML" control={<Radio />} label="XML" />
      </RadioGroup>

      {selectedFormat === 'URL' ? (
        <>
          <InputMultipleLines
            label="Informe a URL fornecida pelo provedor de identidade (IdP)"
            value={idpConfig?.metadataUrl}
            onChange={handleUrlInputChange}
          />
        </>
      ) : (
        <>
          <InputMultipleLines
            label="Informe o texto XML fornecido pelo provedor de identidade (IdP)"
            value={idpConfig?.metadataXml}
            multiline={true}
            rows={5}
            style={{ marginBottom: '5px' }}
            onChange={handleXmlInputChange}
          />
        </>
      )}
    </FormControl>
  );
};

export default TypeFormat;
